import { render, staticRenderFns } from "./StatsBonusTipsModal.vue?vue&type=template&id=36f38721&"
import script from "./StatsBonusTipsModal.vue?vue&type=script&lang=js&"
export * from "./StatsBonusTipsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports